import { render, staticRenderFns } from "./AgendaPlanItemAdvancedPopup.vue?vue&type=template&id=63c16264"
import script from "./AgendaPlanItemAdvancedPopup.vue?vue&type=script&lang=ts"
export * from "./AgendaPlanItemAdvancedPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports